// Hook usunięcia komentarza – DELETE /sales-crm/clients/:cid/offers/:oid/positions/:pid/comments/:commentId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteSalesCrmOfferPositionComment = (
  clientId: number,
  offerId: string,
  positionId: number,
  commentId: number
): Promise<IResponse> =>
  axios.delete(
    `/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}/comments/${commentId}`
  );

export const useDeleteSalesCrmOfferPositionComment = (
  clientId: number,
  offerId: string,
  positionId: number,
  options?: UseMutationOptions<IResponse, IError, number>
) =>
  useMutation(
    (commentId: number) =>
      deleteSalesCrmOfferPositionComment(clientId, offerId, positionId, commentId),
    options
  );
